import { DefaultService } from '@/services/DefaultService';

export default class AssClienteEnderecoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAllVendas(column, order, page, limit, situacao, id, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/cliente/endereco.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllAgro(column, order, page, limit, situacao, id, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/cliente/endereco.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${id}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacaoVendas(endereco) {
        return this._http.post(`${this._env}/ven/cliente/endereco/updatesituacao`, endereco, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(endereco) {
        return this._http.post(`${this._env}/agro/cliente/endereco/updatesituacao`, endereco, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    //preencher campos de endereço baseado no CEP informado 
    getInfoByCEP(cep, token){
        return this._http.post(`${this._env}/consultacep/${cep}`, {token: token},
            {'Content-Type': 'application/json'}
        ).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    //preencher campos de acordo com o CNPJ informado 
    getInfoByCNPJ(uf, cnpj){
        return this._http.get(`${this._env}/general/cnpj.json?uf=${uf}&cnpj=${cnpj}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    //atualizar a latitude e longitude de um endereço de acordo com a localização no Maps
    updateLocation (endereco) {
        return this._http.post(`${this._env}/ven/cliente/endereco/location`, endereco, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findVendas(id) {
        return this._http.get(`${this._env}/ven/cliente/endereco/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAgro(id) {
        return this._http.get(`${this._env}/agro/cliente/endereco/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveVendas(lista) {
        return this._http.post(`${this._env}/ven/cliente/endereco`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveAgro(lista) {
        return this._http.post(`${this._env}/agro/cliente/endereco`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    verificaEnderecoPadrao(endereco){
        return this._http.post(`${this._env}/ven/cliente/endereco/padrao`, endereco, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    } 

    atualizaEnderecoPadrao(endereco){
        return this._http.post(`${this._env}/ven/cliente/endereco/update`, endereco, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}